module.exports = __webpack_public_path__ + "img/map@2x.76715480.png";